export const pl = {
  auth: {
    continue: "Kontynuuj",
    sign_in: "Zaloguj się",
    signing_in: "Logowanie",
    signing_up: "Rejestracja",
    sign_up: "Zarejestruj się",
    sign_up_promo: "Zarejestruj się w Legal Torch {freeText} i odkryj nowe możliwości!",
    sign_up_free: "ZA DARMO",
    login: "Zaloguj się",
    logout: "Wyloguj się",
    register: "Zarejestruj się",
    password: "Hasło",
    forgot_password: "Odzyskiwanie hasła",
    forgot_password_link: "Zapomniałeś hasła?",
    forgot_password_subtitle: "Wpisz swój adres e-mail, a wyślemy Ci link do zmiany hasła.",
    confirm_password: "Powtórz hasło",
    create_account: "Nie masz konta?",
    already_have_account: "Masz już konto?",
    no_account: "Nie masz konta?",
    reset_password: "Zmień hasło",
    "Reset Password": "Zmień hasło",
    reset_password_subtitle: "Wprowadź nowe hasło poniżej, aby zresetować hasło do swojego konta.",
    recaptcha: "Potwierdź, że nie jesteś robotem",
    remember_me: "Zapamiętaj mnie",
    remember_me_hint: "Pozostań zalogowany przez 7 dni",
    remember_the_password: "Pamiętasz hasło?",
    need_help: "Potrzebujesz pomocy?",
    password_required: "Hasło jest wymagane",
    confirm_password_required: "Potwierdź swoje hasło",
    login_with_google: "Zaloguj się z Google",
    login_with_microsoft: "Zaloguj się z Microsoft",
    login_with_apple: "Zaloguj się z Apple",
    register_with_google: "Zarejestruj się z Google",
    register_with_microsoft: "Zarejestruj się z Microsoft",
    register_with_apple: "Zarejestruj się z Apple",
    password_mismatch: "Hasła nie są identyczne",
    password_requirement_length: "Co najmniej 8 znaków",
    password_requirement_digit: "Co najmniej jedna cyfra",
    password_requirement_uppercase: "Co najmniej jedna wielka litera",
    password_requirement_special: "Co najmniej jeden znak specjalny",
    passwords_match: "Hasła są identyczne",
    try_as_guest: "Wypróbuj jako gość",
    no_account_yet: "Nie chcesz jeszcze zakładać konta?",
    accept_terms_as_guest: "Aby wypróbować jako gość, akceptuję",
    accept_terms_to_continue: "Aby kontynuować, akceptuję",
    terms_and_conditions: "Regulamin",
    privacy_policy: "Politykę Prywatności",
    and_the: "i",
    or_use: "Lub użyj",
    verification_required: "Wymagana weryfikacja",
    verification_subtitle: "Aby kontynuować, musisz najpierw zweryfikować swój e-mail.",
    verification_email_sent:
      "Wiadomość weryfikacyjna została wysłana na adres {email}. Jeśli nie otrzymałeś wiadomości, sprawdź folder ze spamem.",
    verification_resend_instruction:
      "W razie potrzeby możesz ponownie wysłać e-mail, klikając poniższy przycisk.",
    resend_email: "Wyślij ponownie e-mail",
    back_to_login: "Wróć do logowania",
  },
  invoice: {
    address: "Adres",
    city: "Miasto",
    zip_code: "Kod pocztowy",
    country: "Kraj",
    tin_number: "NIP",
  },
  chat: {
    ai_assistant: "Asystent Prawny AI",
    new_document_welcome_message: "Nie wiesz, który dokument wybrać? Zapytaj mnie o pomoc!",
    do_you_need_help: "Nie wiesz, którą umowę wybrać?",
    ask_legal_assistant:
      "Opisz krótko swoją sytuację, a nasz Asystent AI zaproponuje Ci najbardziej odpowiedni szablon.",
    virtual_assistant: "Asystent Prawny AI",
    ai_legal_assistant: "Asystent Prawny AI",
    lawyer: "Prawnik",
    message_placeholder: "Zadaj pytanie...",
    creator_welcome_message:
      "Witaj! Jestem Asystentem Prawnym AI. Jestem tu, aby pomóc - zapytaj mnie o cokolwiek.",
    disclaimer:
      "Ta wiadomość została wygenerowana przez AI i nie powinna być traktowana jako porada prawna.",
    disclaimer_1: "Aby skorzystać z Asystenta Prawnego AI, przeczytaj poniższe informacje:",
    disclaimer_2:
      "Pamiętaj: Legal Torch jest narzędziem do generowania umów i nie zastępuje profesjonalnej porady prawnej. W razie wątpliwości skonsultuj się z prawnikiem.",
    disclaimer_3: "Zapisz mój wybór, by nie potwierdzać tego ponownie",
    disclaimer_4: "Tak, rozumiem",
    sample_messages: ["Podsumuj dokument", "Podaj kluczowe zagadnienia"],
  },
  billing: {
    plan: "Plan",
    next_payment: "Następna płatność",
    subscription_cancelled: "Anulowano pomyślnie",
    subscription_resumed: "Wznowiono pomyślnie",
    subscription: "Szczegóły planu",
    subscription_title: "Roczna subskrypcja",
    subscription_coverage: "Zakres subskrypcji",
    extended_subscription: "Subskrypcja premium",
    choose_subscription: "Wybierz plan subskrypcji",
    cancel_subscription: "Anuluj subskrypcję",
    cancel_subscription_message: "Potwierdzasz rezygnację z subskrypcji? Zastanów się jeszcze!",
    payment_history: "Historia płatności",
    manage_subscription: "Zarządzaj",
    payment_method: "Metoda płatności",
    payment_date: "Data płatności",
    payment_required: "Wymagana płatność",
    payment_subtitle: "Aby sfinalizować dokument, prosimy o dokonanie płatności.",
    per_month: "netto miesięcznie",
    one_time: "netto płatne jednorazowo",
    per_document: "netto za dokument",
    buy_now: "Kup teraz",
    total: "Suma",
    plans_benefits2: {
      one_time: [
        "Idealne rozwiązanie, gdy liczy się czas",
        "Zapłać tylko za to, czego potrzebujesz",
        "Stworzona i zweryfikowana przez doświadczonych prawników",
      ],
      recurring: ["Nieograniczone tworzenie dokumentów", "Pełny dostęp do wszystkich funkcji"],
      one_time_payment: [
        "Korzystaj z biblioteki 45+ umów opracowanych przez prawników",
        "Oszczędzaj czas i pieniądze bez żadnych limitów",
        "Działaj zawsze zgodnie z prawem",
      ],
    },
    extended_option: "Opcja jednorazowa - wybierz, zapłać i korzystaj od razu",
    selected_templates: "Wybrane szablony",
    selected_templates_details:
      "(edycja, personalizacja, drukowanie, pobieranie, udostępnianie, tryb negocjacji, podpis elektroniczny)",
    ai_assistant: "Wsparcie AI dla wybranych dokumentów",
    ai_assistant_details:
      "Ograniczony dostęp do Asystenta Prawnego AI: Wyszukiwanie umów - 20 000 znaków/miesiąc i pomoc w personalizacji dokumentu - 100 000 znaków/miesiąc",
    limited_dashboard: "Ograniczony dostęp do panelu użytkownika",
    limited_dashboard_details: "(brak możliwości tworzenia folderów)",
    single_document: "Stwórz swój dokument",
    free_plan: "Co otrzymujesz w Planie Darmowym?",
    free: "Darmowy",
    free_subscription:
      "Korzystasz z Planu Darmowego! Ciesz się wyszukiwaniem dokumentów i korzystaniem z darmowych szablonów z podstawową edycją. Chcesz więcej funkcji? W każdej chwili możesz ulepszyć swój plan lub kupić pojedyncze dokumenty!",
    free_subscription_details: "Dostęp do podstawowych szablonów umów",
    free_subscription_details_info: "Twórz dokumenty, edytuj je i pobieraj na swój komputer.",
    free_subscription_ai_assistant: "Podstawowe wsparcie Asystenta Prawnego AI",
    free_subscription_ai_assistant_info:
      "Skorzystaj z pomocy AI do analizy i personalizacji darmowych umów.",
    free_subscription_dashboard: "Twoje osobiste archiwum umów",
    free_subscription_dashboard_details:
      "Przechowuj i zarządzaj swoimi dokumentami w jednym bezpiecznym miejscu.",
    join_premium_subscription_title: "Co zyskujesz w Planie Premium?",
    join_premium_subscription_feature1: "Twórz i zarządzaj dowolną liczbą umów",
    join_premium_subscription_feature1_desc:
      "Korzystaj z nielimitowanego dostępu do wszystkich szablonów, które możesz edytować, personalizować, drukować i udostępniać.",
    join_premium_subscription_feature2: "Oszczędzaj czas dzięki Asystentowi Prawnemu AI",
    join_premium_subscription_feature2_desc:
      "Błyskawicznie analizuj dokumenty, znajduj ryzykowne zapisy bez żadnych limitów",
    join_premium_subscription_feature3: "Korzystaj z zaawansowanych narzędzi w panelu użytkownika",
    join_premium_subscription_feature3_desc:
      "Używaj trybu negocjacji, duplikuj umowy jednym kliknięciem i zarządzaj wszystkimi dokumentami w jednym miejscu.",
    single_document_title:
      "Opcja jednorazowa – idealna, gdy potrzebujesz jednego szablonu. Co otrzymujesz w ramach jednorazowego zakupu?",
    single_document_feature1: "Dostęp do wybranego przez Ciebie szablonu umowy",
    single_document_feature1_desc: "Pobierz jeden, dowolny szablon z naszej pełnej biblioteki.",
    single_document_feature2: "Pełna edycja i personalizacja",
    single_document_feature2_desc:
      "Dostosuj dokument do swoich potrzeb, drukuj go i udostępniaj bez ograniczeń.",
    single_document_feature3: "Jednorazowe wsparcie Asystenta AI",
    single_document_feature3_desc:
      "Wykorzystaj Asystenta do analizy i poprawy Twojego dokumentu w ramach limitów",
    single_document_feature4: "Dostęp do dokumentu w Twoim panelu",
    single_document_feature4_desc: "Przechowuj i wracaj do swojego dokumentu w dowolnym momencie.",
    premium_plan: "Plan Premium",
    premium_subscription:
      "Witaj w Planie Premium🎉! Ciesz się nieograniczonym dostępem do pełnej biblioteki dokumentów, spersonalizowanym wsparciem Asystenta Prawnego AI i kompleksowym panelem do łatwego zarządzania umowami. Dziękujemy, że jesteś cenionym członkiem naszej społeczności!",
    premium_subscription_details:
      "Ciesz się nieograniczonym dostępem do wszystkich szablonów przez cały okres subskrypcji!",
    premium_subscription_details_info:
      "(Edycja, personalizacja, drukowanie, pobieranie, udostępnianie, tryb negocjacji, duplikowanie umów)",
    premium_subscription_ai_assistant: "Nieograniczony dostęp do Asystenta Prawnego AI",
    premium_subscription_dashboard: "Pełny dostęp do panelu użytkownika",
    traditional_payments: "Płatność online",
    crypto_payments: "Zapłać VAI Tokenem",
    crypto_discount: "Zapłać VAI tokenem i zyskaj -30%",
  },
  documents: {
    new_document: "Nowy dokument",
    new_document_instruction: "Instrukcja",
    new_document_instruction_step_1: "Wybierz szablon odpowiadający Twoim potrzebom.",
    new_document_instruction_step_2:
      "Nie wiesz, który szablon wybrać? Zapytaj Asystenta Prawnego AI lub skorzystaj z wyszukiwarki.",
    new_document_instruction_step_3: "Wypełnij dokument swoimi danymi.",
    new_document_instruction_step_4: "Jeśli to konieczne, możesz podpisać dokument elektronicznie.",
    popular_templates: "Popularne szablony",
    my_documents: "Moje dokumenty",
    use_template: "Wybierz szablon",
    create_document: "Nowy dokument",
    create_directory: "Nowy folder",
    remove_directory: "Usuń folder",
    no_documents: "Brak dostępnych dokumentów.",
    new_directory_subtitle: "Wprowadź nazwę dla folderu",
    move_to_directory: "Przenieś do folderu",
    remove_from_directory: "Usuń z folderu",
    move_to_new_directory: "Przenieś do nowego folderu...",
    show_history: "Pokaż historię",
    change_history: "Historia zmian",
    current_version: "Aktualna wersja",
    previous_version: "Poprzednia wersja",
    next_version: "Kolejna wersja",
    send_to_verification: "Wyślij do weryfikacji",
    preview: "Podgląd",
    name: "Nazwa dokumentu",
    folder_name: "Nazwa folderu",
    type: "Typ",
    status: "Status",
    // New translations for modern design
    manage_documents_subtitle: "Organizuj, edytuj i zarządzaj wszystkimi swoimi dokumentami prawnymi w jednym miejscu",
    search_documents: "Szukaj dokumentów...",
    filter_by_status: "Filtruj według statusu",
    directories: "Foldery",
    recent_documents: "Ostatnie dokumenty",
    document: "Dokument",
    no_documents_title: "Brak dokumentów",
    no_documents_description: "Rozpocznij od utworzenia pierwszego dokumentu z naszej biblioteki szablonów",
    create_first_document: "Utwórz pierwszy dokument",
    no_results: "Nie znaleziono dokumentów",
    showing_results: "Wyświetlanie {count} dokumentów",
    folder_contains_documents: "Zawiera {count} dokumentów",
    statuses: {
      draft: "Wersja robocza",
      verification_or_signature: "Do weryfikacji lub podpisu",
      under_negotiation: "W trakcie negocjacji",
      ready_for_signature: "Gotowy do podpisu",
      signed: "Podpisany",
      completed: "Zakończony",
      Draft: "Wersja robocza",
      Completed: "Zakończony",
    },
    signatures: {
      sign: "Podpisz",
      sign_document: "Podpisz dokument",
      sign_documents: "Podpisz dokumenty",
      documents_to_sign: "Dokumenty do podpisania",
      upload_new_document_and_sign: "Wgraj i podpisz nowy dokument",
      pdf_files_digitally: "Podpisz elektronicznie pliki PDF",
      select_a_document_from_the_platform: "Wybierz dokument z platformy",
      select_a_document_from_your_device: "Wybierz plik ze swojego urządzenia",
      or_drag_and_drop_here: "Lub przeciągnij i upuść tutaj",
      document_size: "Rozmiar dokumentu",
      document_extension: "Format pliku",
      signing_format: "Format podpisu",
      pdf_file_in_pades: "Plik PDF w formacie PAdES",
      go_sign: "Przejdź do podpisu",
      other_in_xades: "Inne w formacie XAdES",
      learn_more_about_pades_and_xades_formats: "Dowiedz się więcej o formatach PAdES i XAdES",
      recommended_browsers: "Zalecane przeglądarki",
      show_ready_documents: "Zobacz dokumenty oczekujące na Twój podpis",
    },
    duplicate: "Duplikuj",
    accept_document: "Zaakceptuj dokument",
    document_accepted: "Dokument zaakceptowany",
    negotiation_header: "Witaj w trybie negocjacji – zaczynajmy!",
    negotiation_description:
      "W tym module możesz dodawać komentarze do dokumentu lub konkretnych sekcji, aby zasugerować zmiany. Jeśli dokument spełnia Twoje oczekiwania, kliknij przycisk poniżej, aby go zaakceptować. Druga strona zostanie automatycznie powiadomiona o Twojej decyzji. Rozpocznij negocjacje i współpracuj, aby osiągnąć najlepszy rezultat!",
    subscription_or_single_payment_required:
      "Aby edytować ten dokument, wykup go ponownie lub przejdź na plan subskrypcyjny",
    delete_document: 'Czy na pewno chcesz usunąć dokument "{name}"',
    delete_document_description: "Potwierdź, że chcesz usunąć ten dokument.",
    delete_confirmation_title: "Potwierdzenie usunięcia",
    delete_irreversible_warning: "Ta operacja jest nieodwracalna",
    delete_success: "Dokument został pomyślnie usunięty",
    show_comments: "Pokaż komentarze",
    sign_hint: "Zakończ proces tworzenia umowy aby ją podpisać.",
    download_locked_hint: "Zakończ proces tworzenia umowy aby ją pobrać.",
    move_to_folder_locked_hint: "Najpierw musisz utworzyć folder w zakładce Moje dokumenty",
    move_to_folder_subscription_required: "Ta funkcja wymaga subskrypcji.",
    move_to_folder_no_folders:
      "Najpierw utwórz folder w Moich Dokumentach, aby korzystać z tej funkcji.",
    duplicate_locked_hint: "Ta funkcja wymaga subskrypcji",
    sign_locked_hint: "Ta funkcja wymaga subskrypcji lub płatności za dokument",
    save_disabled_phase1: "Zakończ proces tworzenia dokumentu aby go zapisać.",
    save_disabled_payment_required:
      "Ten płatny dokument wymaga subskrypcji lub płatności aby go zapisać.",
    register_required: "Zarejestruj się, aby zapisywać dokumenty.",
    register_required_feature: "Zarejestruj się, aby korzystać z tej funkcji.",
    no_changes_to_save: "Brak zmian do zapisania.",
    print_disabled_phase1: "Zakończ proces tworzenia dokumentu aby go wydrukować.",
    comments_disabled_phase1: "Zakończ proces tworzenia dokumentu aby zobaczyć komentarze.",
    history_disabled_early: "Ukończ pierwszą część dokumentu aby zobaczyć historię.",
  },
  header: {
    promo_text_part1: "TWÓRZ UMOWY W KILKA MINUT,",
    promo_text_part2: "TERAZ 40% TANIEJ!",
    promo_text_part3: "SKORZYSTAJ Z KODU",
    promo_text_part4: "PROMO40",
    promo_code_banner: "Kod -40%: PROMO40",
  },
  common: {
    email: "Email",
    name: "Imię i nazwisko",
    phone: "Numer telefonu",
    or: "lub",
    and: "i",
    sending: "Wysyłanie...",
    sent: "Wysłano!",
    loading: "Ładowanie...",
    save: "Zapisz",
    edit: "Edytuj",
    file: "Plik",
    share: "Udostępnij",
    search_bar_placeholder: "Wyszukaj lub zapytaj Asystenta Prawnego AI",
    home: "Strona główna",
    new_document: "Nowy dokument",
    document_templates: "Wzory dokumentów",
    documents: "Dokumenty",
    profile: "Profil",
    guest: "Gość",
    search: "Wyszukaj",
    created_at: "Utworzono",
    show: "Pokaż",
    preview: "Podgląd",
    hide: "Ukryj",
    send: "Wyślij",
    load_more: "Pokaż więcej",
    cancel: "Anuluj",
    create: "Utwórz",
    clear_filters: "Wyczyść filtry",
    upgrade_subscription: "Ulepsz plan",
    upgrade: "Ulepsz",
    upgrade2: "Aktywuj plan roczny",
    confirm: "Potwierdź",
    confirm_changes: "Czy chcesz zapisać zmiany?",
    discard: "Odrzuć",
    resume: "Wznów",
    manage: "Zarządzaj",
    close: "Zamknij",
    choose: "Wybierz",
    status: "Status",
    starts_at: "Subskrypcja od",
    ends_at: "Koniec subskrypcji",
    previous: "Poprzedni",
    next: "Dalej",
    save_as: "Zapisz jako",
    change_name: "Zmień nazwę",
    print: "Drukuj",
    delete: "Usuń",
    open: "Otwórz",
    move: "Przenieś",
    directory: "Katalog",
    reset: "Resetuj",
    requiresAuth: "Wymagana autoryzacja",
    requiresAuthMessage: "Musisz być zalogowany, aby uzyskać dostęp do tej funkcji",
    subscribe: "Plan roczny",
    subscriptionRequired: "Wymagana subskrypcja",
    subscriptionRequiredMessage: "Subskrybuj, aby uzyskać dostęp do tej funkcji.",
    subscriptionOrSinglePaymentRequired: "Wymagana płatność",
    subscriptionOrSinglePaymentRequiredMessage: "Opłać dokument, aby go ukończyć",
    notifications: "Powiadomienia",
    youAreUpToDate: "Jesteś na bieżąco",
    markAllAsRead: "Oznacz wszystkie jako przeczytane",
    dateOfCreation: "Data utworzenia",
    type: "Rodzaj",
    amount: "Kwota",
    restore: "Przywróć",
    from: "Od",
    back: "Wstecz",
    forward: "Dalej",
    select: "Wybierz",
    sign: "Podpisz",
    menu: "Menu",
    buy: "Kup teraz",
    findDocument: "Znajdź",
    download: "Pobierz",
    sent_at: "Wysłano",
    opened_at: "Otwarto",
    history_of_sharing: "Historia udostępniania",
    settings: "Ustawienia",
    need_help: "Potrzebujesz pomocy?",
    form: "Formularz",
    attention: "Uwaga",
  },
  templateCategories: {
    all: "Wszystkie",
    employment_contracts: "Umowy o pracę",
    business_contracts: "Umowy biznesowe",
    real_estate: "Lokale i nieruchomości",
    companies: "Spółki handlowe",
    online_business: "Biznes w sieci",
    family_and_property: "Sprawy rodzinne i majątkowe",
  },
  templates: {
    no_templates_found: "Nie znaleziono szablonów",
    try_different_search: "Spróbuj innych słów kluczowych lub zmień kategorię",
  },
  creator: {
    new_document: "Nowy dokument",
    wysiwyg_wizard_locked: "Najpierw odpowiedz na kilka pytań",
    wizard: "Kreator",
    form: "Formularz",
    copy_link: "Kopiuj link",
    share_email: "Udostępnij przez email",
    ask_for_email: "Wprowadź adres email, na który chcesz wysłać dokument",
    send: "Wyślij do weryfikacji",
    change_document_name: "Zmień nazwę dokumentu",
    change_document_name_description: "Wprowadź nową nazwę dla dokumentu",
    hidden_paragraph_tooltip: "Aby zobaczyć pełną treść, utwórz konto",
    toolbar: {
      font: "Czcionka",
      format: "Format",
      color: "Kolor",
      spacing: "Odstępy",
      size: "Rozmiar",
      text: "Tekst",
      background: "Tło",
      line_height: "Interlinia",
      disabled_wizard: "Zakończ proces tworzenia umowy, aby skorzystać z tej funkcjonalności",
    },
  },
  notifications: {
    default_error: "Ups! Coś poszło nie tak.",
    default_update_success: "Zaktualizowano pomyślnie!",
    email_change: 'Zweryfikuj swój nowy adres email "{email}",  aby zakończyć zmianę.',
    login_success: "Zalogowano pomyślnie!",
    login_error: "Nieprawidłowe dane logowania",
    guest_login_success: "Witaj! Przeglądasz teraz jako gość.",
    logout_success: "Wylogowano pomyślnie!",
    register_success: "Zarejestrowano pomyślnie!",
    verification_email_sent: "E-mail został wysłany!",
    auth_error_account_exists:
      "Konto z podanymi danymi już istnieje. Zaloguj się, aby kontynuować.",
    document_moved: "Przeniesiono dokument",
    document_saved: "Zapisano dokument",
    no_changes_to_save: "Brak zmian do zapisania",
    directory_removed: "Usunięto folder",
    directory_created: "Utworzono nowy folder",
    link_copied: "Skopiowano link",
    link_copy_error: "Nie można skopiować linku",
    password_reset_success: "Zmieniono hasło",
    forgot_password_success: "Sprawdź skrzynkę email - wysłaliśmy link do zmiany hasła.",
    document_deleted: "Usunięto dokument",
    document_save_error: "Błąd podczas zapisywania dokumentu",
    chat_char_limit: "Wykorzystałęś limit czatu na ostatnie 30 dni. Sprawdź ponownie później!",
    logout_warning: "Zostaniesz wkrótce automatycznie wylogowany z powodu braku aktywności.",
    document_duplicated: "Utworzono kopię dokumentu",
    document_duplicate_error: "Ups! Nie udało się zduplikować dokumentu. Spróbuj ponownie.",
    document_name_updated: "Zmieniono nazwę dokumentu",
    wizard_completed: "Dokument gotowy! 🎉",
  },
  errors: {
    global: {
      too_many_request:
        "Wykonałeś zbyt wiele zapytań. Poczekaj chwilę i spróbuj ponownie za minutę.",
    },
    documents: {
      not_found: "Nie znaleziono dokumentów",
      move_error: "Błąd podczas przenoszenia dokumentu",
      save_error: "Błąd podczas zapisywania dokumentu",
      directory_removal_error: "Błąd podczas usuwania folderu",
      directory_creation_error: "Błąd podczas tworzenia folderu",
      name_required: "Wymagana nazwa dokumentu",
      document_delete_error: "Błąd podczas usuwania dokumentu",
    },
    auth: {
      terms_required: "Wymagana akceptacja regulaminu i polityki prywatności.",
      invalid_credentials: "Nieprawidłowy email lub hasło",
    },
    search: {
      no_categories: "Nie udało się załadować listy kategorii",
    },
    editor: {
      prohibited_action: "Nie możesz usunąć tej treści",
      variable_value_required: "To pole jest wymagane",
    },
    chat: {
      limit_general: "Osiągnąłeś limit czatu na ostatnie 30 dni. Kup subskrypcję, aby kontynuować.",
      limit_document:
        "Osiągnąłeś limit czatu dla tego dokumentu. Kup subskrypcję, aby kontynuować.",
    },
    wizard: {
      max_options1: "Możesz wybrać maksymalnie",
      max_options2: "opcji",
      min_options: "Wybierz minimum jedną opcję",
    },
  },
  static_pages: {
    "Cookies Policy": "Polityka plików cookie",
    "Privacy Policy": "Polityka prywatności",
    "Terms Of Service": "Regulamin",
    "About Us": "O nas",
    "Frequently Asked Questions": "Często zadawane pytania",
    "AI Disclaimer": "Zastrzeżenia dotyczące AI",
    "Ai Disclaimer": "Zastrzeżenia dotyczące AI",
  },
  footer: {
    credits: "©2024 VAIOT Limited",
  },
  home: {
    active_documents: "Dokumenty w toku",
    latest_documents: "Ostatnio utworzone",
    latest_documents_mobile: "Ostatnio utworzone dokumenty",
  },
  account: {
    delete_account: "Usuń konto",
    delete_account_message: "Czy na pewno chcesz usunąć swoje konto?",
    delete_account_warning: "Uwaga! Ta akcja jest nieodwracalna.",
    delete_verify_code: 'Wpisz "USUŃ" aby potwierdzić usunięcie konta',
    delete_account_reason_message: "Dlaczego chcesz usunąć konto?",
    delete_account_reason: "Powód usunięcia",
    delete_account_reason_required: "Proszę podać powód usunięcia konta.",
    change_password: "Zmień hasło",
    current_password: "Aktualne hasło",
    new_password: "Nowe hasło",
    confirm_new_password: "Potwierdź nowe hasło",
    password_changed: "Hasło zostało zmienione pomyślnie",
  },
  email_popup: {
    title: "Dokończ rejestrację konta",
    description:
      "Jesteś już blisko! Dokończ rejestrację, aby z łatwością zarządzać wszystkimi dokumentami w jednym miejscu.",
    button: "Dokończ rejestrację",
  },
  term_popup: {
    title: "Witaj! Zanim zaczniemy...",
    subtitle: "Aby korzystać z aplikacji, potrzebujemy Twojej zgody.",
    subtitle_part_1: "Aby korzystać z aplikacji,",
    subtitle_part_2: "potrzebujemy Twojej zgody.",
    description: {
      full: "Akceptuję <a href='{termsLink}' target='_blank'>{terms}</a> oraz zapoznałem/am się z <a href='{privacyLink}' target='_blank'>{privacy}</a>.",
    },
    button: "Akceptuję",
    terms_and_conditions: {
      title: "Warunki korzystania",
      link: "warunki korzystania",
    },
    privacy_policy: {
      title: "Polityką prywatności",
      link: "polityka prywatności",
    },
  },
  marketing_consent: "Tak, chcę otrzymywać informacje o nowościach, promocjach i poradach.",
  profile: {
    user_profile: "Moje konto",
    account_details: "Szczegóły konta",
    change_password: "Zmiana hasła",
    contact_details: "Dane kontaktowe",
    invoice_details: "Dane do faktury",
  },
  wizard: {
    progress: "Postęp",
  },
  contact_form: {
    contact_support: "Wsparcie techniczne",
    name: "Imię i nazwisko",
    email: "Email",
    subject: "Temat",
    describe_your_problem: "Opisz swój problem",
    send: "Wyślij",
    message_sent_successfully: "Wiadomość wysłana pomyślnie",
    share_your_feedback: "Podziel się swoją opinią",
    subject_types: [
      "Konto i rozliczenia",
      "Wsparcie dotyczące dokumentów",
      "Prawo i prywatność",
      "Pomoc techniczna",
      "Opinia",
      "Inne",
    ],
  },
  docusign: {
    auth_success: "Autoryzacja DocuSign zakończona pomyślnie",
    warning_blocking_windows:
      "Uwaga! Proces podpisywania dokumentu odbywa się przez DocuSign, który otworzy się w nowej karcie. Upewnij się, że Twoja przeglądarka nie blokuje tego okna.",
    upload_success: "Przesłano dokument do DocuSign",
    upload_error: "Błąd podczas przesyłania do DocuSign",
    connect_your_account: "Połącz swoje konto DocuSign",
    redirect_error: "Błąd przekierowania do DocuSign",
  },
  comments: {
    title: "Komentarze",
    add_comment: "Dodaj komentarz",
    comment_placeholder: "Wpisz swój komentarz tutaj...",
    comment_added: "Dodano komentarz",
    comment_removed: "Usunięto komentarz",
    comment_remove_error: "Błąd: Nie można usunąć komentarza",
    comment_add_error: "Błąd: Nie można dodać komentarza",
  },
  validation: {
    required: "To pole jest wymagane",
    email: "Nieprawidłowy adres email",
    field_required: "To pole jest wymagane",
    password_min_length: "Hasło musi mieć co najmniej 8 znaków",
    password_digit: "Hasło musi zawierać co najmniej jedną cyfrę",
    password_uppercase: "Hasło musi zawierać co najmniej jedną wielką literę",
    password_special: "Hasło musi zawierać co najmniej jeden znak specjalny",
    user_already_exists: "Użytkownik z tym adresem email już istnieje",
  },
  maintenance: {
    title: "Przerwa Techniczna",
    description:
      "Obecnie przeprowadzamy zaplanowane prace techniczne, aby ulepszyć nasze usługi. Wkrótce wrócimy online. Dziękujemy za cierpliwość!",
    status: "Prace Techniczne w Toku",
  },
  welcome: {
    title: "Witaj W Legal Torch",
    description:
      "Tworzenie dokumentu z LegalTorch jest szybkie, proste i w pełni online. Wystarczy wybrać szablon, wypełnić dane i – jeśli chcesz – podpisać całość elektronicznie. Nasz Asystent Prawny AI pomoże Ci na każdym etapie.",
    step1_title: "Wybierz Szablon",
    step1_description:
      "Zacznij od wyboru odpowiedniego wzoru. Przeszukaj dostępne szablony dokumentów i wybierz ten, który najlepiej odpowiada Twoim potrzebom.",
    step2_title: "Odpowiedz Na Pytania",
    step2_description:
      "Dostosuj dokument do swojej sytuacji. Na podstawie Twoich odpowiedzi automatycznie dopasujemy treść dokumentu.",
    step3_title: "Uzupełnij Dane",
    step3_description:
      "Uzupełnij szczegóły i zakończ edycję. Wprowadź konkretne informacje, takie jak dane stron, daty czy warunki. Po tym kroku Twój dokument będzie gotowy do pobrania lub podpisania.",
    create_new_document: "Stwórz nowy dokument",
  },
  templateSelection: {
    title: "Wybierz szablon",
    description:
      "Opisz swoją sytuację w czacie – nasz wirtualny asystent podpowie, jaką umowę najlepiej pasuje do Twojej sprawy.",
    askAI: "Zapytaj asystenta AI",
    or: "lub wyszukaj samodzielnie",
    selectTemplate: "Znajdź dokument",
    searchTemplate: "Wyszukaj szablon",
    noResults: "Nie znaleziono szablonów pasujących do wyszukiwania",
    proceed: "Dalej",
    freeDocuments: "Dokumenty darmowe",
    premiumDocuments: "Dokumenty premium",
  },
  documentQuestions: {
    title: "Odpowiedz na pytania",
    description:
      "Odpowiedz na kilka krótkich pytań, aby dostosować treść dokumentu do swojej sytuacji. W tym kroku decydujesz, co znajdzie się w umowie.",
    compactDescription: "Dostosuj dokument do swojej sytuacji",
    stepSubtitle: "Wybierz odpowiedź, która najlepiej opisuje Twoją sytuację",
    selectedTemplate: "Wybrany szablon dokumentu",
    documentNamePlaceholder: "Wprowadź nazwę dokumentu...",
    noDocumentToPrint: "Brak dokumentu do wydrukowania",
    noTemplate: "Brak wybranego szablonu",
    backToTemplates: "Wróć do wyboru szablonu",
    changeTemplate: "Zmień szablon",
    noQuestionsNeeded: "Ten szablon nie wymaga dodatkowych pytań",
    proceedToData: "Przejdź do uzupełniania danych",
    editDocument: "Uzupełnij dane",
    editDocumentDescription: "Uzupełnij dane osobowe i szczegóły dokumentu.",
    file: "Plik",
    premiumDocument: "Dokument Premium",
    paymentRequired: "Wymagana jest płatność aby kontynuować",
    documentAvailableDescription: "Ten dokument jest dostępny w ramach subskrypcji lub jako płatność jednorazowa. Wybierz preferowaną opcję płatności, aby kontynuować tworzenie dokumentu.",
    choosePaymentPlan: "Wybierz plan płatności",
    changeTemplateDialog: {
      title: "Zmieniasz szablon?",
      message:
        "Obecny dokument zostanie zapisany i znajdziesz go w zakładce Moje dokumenty. Następnie przejdziesz do wyszukiwarki szablonów, aby wybrać nowy.",
      continue: "Kontynuuj",
      cancel: "Anuluj",
    },
  },
};
